import { createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { IProjectTransmittalItemDocumentType } from './transmittalItemDocumentType.models';

export const apiRoutes = {
  getAllDocumentTypes: '/Transmittals/Items/DocumentTypes',
};

export const getAllTransmittalItemDocumentTypesAsync = createGetOptionsNoPropsFn<IProjectTransmittalItemDocumentType>(
  apiRoutes.getAllDocumentTypes,
);
